import { LATEST_POLICY_UPDATE_ISO } from 'app/config/policyUpdates'

const latestPolicyUpdateDate = new Date(LATEST_POLICY_UPDATE_ISO)

const initialState = () => ({
  needsAcceptance: false
})

export default {
  namespaced: true,

  state: initialState(),

  getters: {
    needsTermsAcceptance(state) {
      return state.needsAcceptance
    }
  },

  mutations: {
    setNeedsAcceptance(state, value) {
      state.needsAcceptance = value
    },

    // Required by sessions/resetEverything: that action iterates every
    // top-level Vuex module and commits `<module>/resetState` to clear
    // per-session state after sign-out or account deletion. Without this
    // mutation Vuex logs "unknown mutation type" warnings during the
    // deletion teardown. Restores `needsAcceptance` to its initial value.
    resetState(state) {
      Object.assign(state, initialState())
    }
  },

  actions: {
    evaluate({ commit }, { account }) {
      if (!account || account.id == null) {
        commit('setNeedsAcceptance', false)
        return
      }

      const acceptedAt = account.termsAcceptedAt
      const acceptedDate = acceptedAt ? new Date(acceptedAt) : null
      const needsAcceptance = !acceptedDate || acceptedDate < latestPolicyUpdateDate

      commit('setNeedsAcceptance', needsAcceptance)
    }
  }
}
